export type SegmentInfo = {
  encoding: 'GSM-7' | 'UCS-2'
  chars: number
  segments: number
  hasVariables: boolean
}

// GSM 03.38 basic character set + LF/CR. One septet each.
const GSM7 = new Set(
  '@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?' +
    '¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑܧ¿abcdefghijklmnopqrstuvwxyzäöñüà\n\r'
)
// Extension table — each costs an escape + char, two septets.
const GSM7_EXT = new Set('^{}\\[~]|€')

const VARIABLE_RE = /\{\{\s*[A-Za-z0-9_]+\s*\}\}/

export const segmentsFor = (body: string): SegmentInfo => {
  const hasVariables = VARIABLE_RE.test(body)
  // variables are EXCLUDED from the count (operator decision 2026-07-14)
  const counted = body.replace(/\{\{\s*[A-Za-z0-9_]+\s*\}\}/g, '')
  let gsm = true
  let gsmChars = 0
  for (const ch of counted) {
    if (GSM7.has(ch)) gsmChars += 1
    else if (GSM7_EXT.has(ch)) gsmChars += 2
    else {
      gsm = false
      break
    }
  }
  if (gsm) {
    const segments =
      gsmChars === 0 ? 0 : gsmChars <= 160 ? 1 : Math.ceil(gsmChars / 153)
    return { encoding: 'GSM-7', chars: gsmChars, segments, hasVariables }
  }
  // UCS-2: UTF-16 code units (astral chars occupy two units).
  const chars = [...counted].reduce(
    (n, ch) => n + ((ch.codePointAt(0) ?? 0) > 0xffff ? 2 : 1),
    0
  )
  const segments = chars === 0 ? 0 : chars <= 70 ? 1 : Math.ceil(chars / 67)
  return { encoding: 'UCS-2', chars, segments, hasVariables }
}
